import { deviceIdDbRe, serialRe } from '~common-helpers';

function buildRegexObj(inputRegexString: string) {
    const flags = inputRegexString.replace(/.*\/([gimy]*)$/, '$1');
    const pattern = inputRegexString.replace(new RegExp('^/(.*?)/' + flags + '$'), '$1');
    return new RegExp(pattern, flags);
}

const mailValidation = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

const deviceNameValidation = '/^[-a-zA-Z0-9 _]{4,}$/';


export function isEmailValid(mail: string) {
    return mail.match((mailValidation)) !== null;
}

export function isDeviceNameValid(name: string) {
    return name.match(buildRegexObj(deviceNameValidation)) !== null;
}

export function isDeviceIdValid(deviceId: string) {
    return deviceIdDbRe.test(deviceId) || serialRe.test(deviceId);
}
